<template>
  <div class="main" v-if="userProfile">
    <div class="main-wrapper">
      <div class="main-title">
        <span
          >{{ $t("personal_page_text") }}
          {{ userProfile.is_admin ? `(${$t("admin")})` : "" }}</span
        >
      </div>
      <v-divider class="divider"></v-divider>
      <div class="main-picture">
        <div
          v-if="userProfile.picture.min || userEditImageSrc"
          class="picture-part"
          style="position: relative"
        >
          <img
            :src="userEditImageSrc ? userEditImageSrc : userProfile.picture.min"
            alt=""
            width="72"
            height="72"
            class="profile-picture"
            @error="onProfilePictureError"
            filters-section
          />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                src="@/assets/images/icons/edit.svg"
                alt="edit"
                v-bind="attrs"
                v-on="on"
                style="
                  margin-left: 28px;
                  position: absolute;
                  background: #fff;
                  border-radius: 50px;
                  top: 50px;
                  left: 20px;
                  padding: 2px;
                "
                @click.prevent="onEditPicture"
              />
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </div>
        <div v-else style="position: relative">
          <img src="@/assets/images/User image.png" alt="" />
          <a
            href="#"
            style="margin-left: 28px"
            @click.prevent="onEditPicture"
            >{{ $t("add_picture") }}</a
          >
          <img
            src="@/assets/images/icons/add-photo.svg"
            alt="edit"
            style="
              margin-left: 28px;
              position: absolute;
              background: #fff;
              border-radius: 50px;
              top: 50px;
              left: 20px;
            "
            @click.prevent="onEditPicture"
          />
        </div>
      </div>
      <div class="main-name">
        <label for="name">
          {{ $t("full_name") }} <span class="red">*</span>
        </label>
        <div
          v-if="!editMode.full_name"
          style="margin-top: 15px"
          class="edit-mobile"
        >
          {{ profile.full_name }}

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                src="@/assets/images/icons/edit.svg"
                alt="edit"
                class="pencil-icon"
                style="margin-left: 25px"
                v-bind="attrs"
                v-on="on"
                @click.prevent="editMode.full_name = true"
              />
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
          <span
            class="red error-message"
            v-if="$v.profile.full_name.$invalid && isBlured"
          >
            This field is required
          </span>
        </div>
        <div class="btns-position" v-else>
          <input
            @blur="
              $v.profile.full_name.$touch();
              isBlured = true;
            "
            @focus="isBlured = false"
            :class="{
              'error-input': $v.profile.full_name.$invalid && isBlured,
            }"
            id="name"
            class="user-input custom-placeholer-color"
            style="color: black"
            :placeholder="$t('for_example') + '` John Doe'"
            v-model="profile.full_name"
          />
          <div class="btns">
            <v-btn
              class="save-btn-new"
              style="color: white"
              @click="handleSaveSettings"
            >
              <img
                src="@/assets/images/icons/myprofile-savebtn.svg"
                alt="save"
              />
            </v-btn>
            <v-btn
              class="cancel-btn-new"
              style="color: #100f0f"
              @click="
                profile.full_name = userProfile.full_name;
                editMode.full_name = false;
              "
            >
              <img
                src="@/assets/images/icons/myprofile-cancelbtn.svg"
                alt="cancel"
            /></v-btn>
          </div>
        </div>
      </div>
      <v-divider class="divider"></v-divider>
      <div class="main-user_type">
        <span>{{ $t("account_type") }}</span>
        <div
          v-if="!editMode.user_type"
          class="d-flex align-items-center edit-mobile"
          style="margin-top: 15px"
        >
          {{ $t(`addproperty.${userProfile.user_type.name}`) }}

          <!-- <img
            src="@/assets/images/icons/edit.svg"
            alt="edit"
            class="change-email pencil-icon"
            style="margin-left: 25px"
            
          /> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                src="@/assets/images/icons/edit.svg"
                alt="edit"
                class="pencil-icon"
                style="margin-left: 25px"
                v-bind="attrs"
                v-on="on"
                @click.prevent="editMode.user_type = true"
              />
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </div>
        <div v-else class="d-flex align-items-center user-type-div">
          <v-select
            v-model="profile.user_type"
            class="user-type-select"
            solo
            color="#04a777"
            item-color="#04a777"
            hide-details
            dense
            :items="userTypes"
            item-text="name"
            item-value="type"
          ></v-select>
          <div class="btns">
            <v-btn
              class="save-btn-new"
              @click="handleSaveSettings"
              style="color: white"
            >
              <img src="@/assets/images/icons/myprofile-savebtn.svg" alt="save"
            /></v-btn>
            <v-btn @click="editMode.user_type = false" class="cancel-btn-new">
              <img
                src="@/assets/images/icons/myprofile-cancelbtn.svg"
                alt="cancel"
            /></v-btn>
          </div>
        </div>
      </div>
      <v-divider class="divider"></v-divider>
      <div class="main-user_email">
        <span>{{ $t("email_text") }}</span>
        <div
          v-if="!editMode.email"
          style="margin-top: 15px"
          class="edit-mobile"
        >
          {{ profile.email }}
          <img
            :src="getProviderIcon(userProfile.provider)"
            width="10"
            height="10"
            alt=""
            v-if="userProfile.provider"
          />
          <!-- <img
            src="@/assets/images/icons/edit.svg"
            alt="edit"
            class="change-email pencil-icon"
            style="margin-left: 25px"
            @click.prevent="editMode.email = true"
          /> -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                src="@/assets/images/icons/edit.svg"
                alt="edit"
                class="pencil-icon"
                style="margin-left: 25px"
                v-bind="attrs"
                v-on="on"
                @click.prevent="editMode.email = true"
              />
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </div>
        <div class="btns-position" v-else>
          <input type="text" class="user-input" v-model="profile.email" />
          <div class="btns">
            <v-btn class="save-btn-new" @click="handleSaveSettings">
              <img
                src="@/assets/images/icons/myprofile-savebtn.svg"
                alt="save"
              />
            </v-btn>
            <v-btn
              class="cancel-btn-new"
              @click="
                profile.email = userProfile.email;
                editMode.email = false;
              "
            >
              <img
                src="@/assets/images/icons/myprofile-cancelbtn.svg"
                alt="cancel"
            /></v-btn>
          </div>
        </div>
      </div>
      <v-divider class="divider"></v-divider>
      <div class="main-user_password">
        <div v-if="!editMode.password">
          <span>{{ $t("password_text") }}</span>
          <div style="margin-top: 15px" class="edit-mobile">
            **********
            <!-- <img
              src="@/assets/images/icons/edit.svg"
              alt="edit"
              class="pencil-icon"
              style="margin-left: 25px"
              @click.prevent="editMode.password = true"
            /> -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <img
                  src="@/assets/images/icons/edit.svg"
                  alt="edit"
                  class="pencil-icon"
                  style="margin-left: 25px"
                  v-bind="attrs"
                  v-on="on"
                  @click.prevent="editMode.password = true"
                />
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
          </div>
        </div>
        <div v-else>
          <v-text-field
            class="mb-2 user-text-field custom-placeholer-color"
            hide-details
            v-model="profile.old_password"
            solo
            color="#04a777"
            :placeholder="$t('old_pass')"
            @click:append="showPass = !showPass"
            :append-icon="showPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :type="showPass ? 'text' : 'password'"
          />
          <v-text-field
            class="mb-2 user-text-field custom-placeholer-color"
            hide-details
            color="#04a777"
            v-model="profile.password"
            @click:append="showPass2 = !showPass2"
            solo
            :append-icon="showPass2 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :type="showPass2 ? 'text' : 'password'"
            :placeholder="$t('new_pass')"
          />
          <v-text-field
            class="mb-2 user-text-field custom-placeholer-color"
            hide-details
            color="#04a777"
            v-model="profile.password_confirmation"
            :placeholder="$t('repeat_password_text')"
            solo
            @click:append="showPass3 = !showPass3"
            :append-icon="showPass3 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            :type="showPass2 ? 'text' : 'password'"
          />
          <br />
          <div>
            <v-btn class="save-btn-new" @click="handleSaveSettings">
              <img
                src="@/assets/images/icons/myprofile-savebtn.svg"
                alt="save"
              />
            </v-btn>
            <v-btn class="cancel-btn-new" @click="onCancelEditPassword">
              <img
                src="@/assets/images/icons/myprofile-cancelbtn.svg"
                alt="cancel"
              />
            </v-btn>
          </div>
        </div>
      </div>
      <v-divider class="divider"></v-divider>
      <div class="main-user_phone">
        <span>{{ $t("tel_number") }}</span>
        <div class="new-number-part mt-2">
          <div class="phone-numbers">
            <div
              v-for="(item, index) in profile.phones"
              :key="`number_${index}`"
              class="main-user_phone-wrapper"
            >
              <div class="phone-number_input">
                <div class="d-flex" style="width: 140px">
                  (+374)
                  <input
                    @update="(val) => onPhoneUpdate(index, val)"
                    :default-country-code="findCode(index)"
                    disabled
                    valid-color="#04a777"
                    color="gray"
                    style="overflow: hidden; margin: 0 10px"
                    @value="phoneNumber"
                    v-model="item.number"
                  />
                </div>
                <div class="d-flex">
                  <div class="d-flex">
                    <img
                      style="margin-right: 8px; margin-top: 5px"
                      src="../../assets/images/icons/Whatsapp.svg"
                      alt=""
                      width="20"
                      v-if="item.whatsapp"
                    />
                  </div>
                  <div>
                    <img
                      style="margin-right: 8px; margin-top: 5px"
                      src="../../assets/images/icons/Viber.svg"
                      alt=""
                      width="20"
                      v-if="item.viber"
                    />
                  </div>
                  <div>
                    <img
                      style="margin-right: 8px; margin-top: 5px"
                      src="../../assets/images/icons/Telegram.svg"
                      alt=""
                      width="20"
                      v-if="item.telegram"
                    />
                  </div>
                </div>
              </div>
              <div class="attached-phone d-flex">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <img
                        src="@/assets/images/icons/edit.svg"
                        alt="edit"
                        style="margin-left: 15px"
                        @click="onEditPhone(index, item.phone_id)"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <span>{{ $t("edit") }}</span>
                  </v-tooltip>
                  <transition name="fade">
                    <div
                      class="warning-box_edit warning-box"
                      ref="phonewarning"
                      v-if="isOpenEditWarning"
                      style="gap: 16px"
                    >
                      {{ $t("edit") }}
                    </div>
                  </transition>
                  <v-tooltip v-if="!phoneLoaders[index]" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <img
                        src="@/assets/images/icons/delete.svg"
                        alt="edit"
                        style="margin-left: 10px"
                        @click="onDeletePhone(item.phone_id, index)"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <span>{{ $t("mainFilters.delete") }}</span>
                  </v-tooltip>
                  <v-progress-circular
                    color="#000"
                    indeterminate
                    v-else
                    size="16"
                  ></v-progress-circular>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex" style="position: relative">
            <v-btn
              outlined
              class="add-new-phone-button"
              :disabled="profile.phones.length >= 3"
              @click="onAddPhone"
            >
              {{ $t("addproperty.add_phone_number") }}
              <v-icon class="ml-2" color="#04a777">mdi-plus-circle</v-icon>
            </v-btn>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <img
                    :src="require('@/assets/images/icons/info.png')"
                    alt=""
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>{{ $t("tel_number_warning") }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
      <v-divider
        v-if="userProfile.user_type.name === 'agency'"
        class="divider"
      ></v-divider>
      <div
        class="main-add-logo pl-4 d-flex"
        v-if="userProfile.user_type.name === 'agency'"
        @click="onClickAddLogo"
      >
        <img src="@/assets/images/icons/upload-in-cloud.svg" />
        <span class="font-weight-bold span-add-logo">{{ $t("add_logo") }}</span>
      </div>
      <v-divider class="divider"></v-divider>
      <div
        class="main-delete-user d-flex"
        style="cursor: pointer"
        @click="onClickDeleteProfile"
      >
        <img src="@/assets/images/delete_account.svg" alt="" />
        <span class="red">{{ $t("remove_account") }}</span>
      </div>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="isOpenAddDialog"
    >
      <template>
        <v-card>
          <v-toolbar color="#04a777" dark>{{ $t("add_phone") }}</v-toolbar>
          <v-card-text style="padding-top: 20px">
            <VuePhoneNumberInput
              @update="onNewNumberUpdate"
              default-country-code="AM"
              valid-color="#04a777"
              color="#04a777"
              v-model="newNumber.number"
            />
            <div class="d-flex account_number" style="gap: 39px">
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="newNumber.viber"
                  :label="`Viber`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="newNumber.whatsapp"
                  :label="`Whatsapp`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="newNumber.telegram"
                  :label="`Telegram`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              :loading="buttonLoading"
              id="custom-disabled"
              :disabled="!newNumber.options.isValid"
              style="color: white; letter-spacing: 0"
              color="#04a777"
              @click="handleAddPhone"
              >{{ $t("save") }}</v-btn
            >
            <v-btn text color="primary" @click="onCloseAddNumber">{{
              $t("addproperty.cancel")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="isOpenEditDialog"
    >
      <template>
        <v-card>
          <v-toolbar color="#04a777" dark>{{ $t("edit_phone") }}</v-toolbar>
          <v-card-text style="padding-top: 20px">
            <VuePhoneNumberInput
              default-country-code="AM"
              valid-color="#04a777"
              color="#04a777"
              v-model="editingPhoneNumber"
            />
            <div class="d-flex account_number" style="gap: 39px">
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="editingNumber.viber"
                  :label="`Viber`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="editingNumber.whatsapp"
                  :label="`Whatsapp`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="editingNumber.telegram"
                  :label="`Telegram`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              :loading="buttonLoading"
              id="custom-disabled"
              style="color: white"
              color="#04a777"
              @click="handleEditPhone"
              >{{ $t("save") }}</v-btn
            >
            <v-btn text @click="onCloseEditNumber">{{
              $t("addproperty.cancel")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="1030px"
      v-model="isOpenEditPictureDialog"
      @click:outside="closeEditPicture"
    >
      <template>
        <v-card>
          <v-toolbar class="edit-picture-header" color="#fff" dark
            >{{ $t("edit") }}
          </v-toolbar>
          <v-card-text class="dialog-body">
            <v-btn absolute top right icon @click="closeEditPicture">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div
              class="cropper-container"
              v-if="
                isOpenEditPictureDialog &&
                !isProfilePictureError &&
                isUploadedImg
              "
            >
              <div class="cropper-wrapper">
                <cropper
                  :resizeImage="{
                    touch: true,
                  }"
                  :default-size="{
                    width: 367,
                    height: 367,
                  }"
                  :auto-zoom="true"
                  :stencilComponent="stencil"
                  class="cropper"
                  :stencilSize="{
                    width: 367,
                    height: 367,
                  }"
                  ref="cropper"
                  :src="profilePictureSrc.src"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    resizable: false,
                    aspectRatio: 1,
                  }"
                  image-restriction="stencil"
                  :canvas="{ height: 500, width: 500 }"
                  @change="onChange"
                  :min-width="150"
                  :min-height="150"
                  :transitions="false"
                />
                <label class="cropper-file-uploade">
                  <input
                    style="display: none"
                    type="file"
                    id="file"
                    ref="file"
                    @change="uploadImage($event)"
                    accept="image/*"
                  />
                  <img
                    src="@/assets/images/icons/camera-black.svg"
                    alt="edit"
                  />
                </label>
              </div>
              <v-card
                class="mx-auto"
                width="600"
                height="32px"
                style="box-shadow: none; margin-top: 30px"
              >
                <v-slider
                  color="#04A777"
                  track-color="grey"
                  always-dirty
                  min="0"
                  max="1"
                  :value="zoom.input"
                  @input="onZoom"
                  step="0"
                >
                  <template v-slot:prepend>
                    <v-icon
                      color="black"
                      class="slider-icons"
                      @click="sliderPrepend"
                    >
                      mdi-minus
                    </v-icon>
                  </template>

                  <template v-slot:append>
                    <v-icon
                      color="black"
                      class="slider-icons"
                      @click="sliderAppend"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                </v-slider>
              </v-card>
            </div>
            <div
              v-if="isProfilePictureError || !profilePictureSrc.src"
              class="no-image-text-box"
            >
              No Image
            </div>
            <div v-show="!isUploadedImg" class="file-input-wrapper">
              <label style="cursor: pointer" class="upload-file">
                <img
                  :src="require(`@/images/${$t('addproperty.add_picture')}`)"
                  width="386"
                  height="280"
                />
                <input
                  type="file"
                  class="file"
                  @change="uploadImage($event)"
                  style="display: none"
                  id="file"
                  ref="files"
                  name="file[]"
                  multiple
                  accept="image/*"
                />
              </label>
            </div>
          </v-card-text>
          <v-card-actions class="justify-center dialog-action-part">
            <!-- <label class="custom-file-upload">
              <input
                style="display: none"
                type="file"
                id="file"
                ref="file"
                @change="uploadImage($event)"
                accept="image/*"
              />
              <img
                src="@/assets/images/icons/camera.png"
                alt=""
                style="margin-right: 10px"
              />
              {{ $t("photoUpload.uploadPhoto") }}
            </label> -->
            <v-btn
              text
              style="
                border: 1px solid #656565;
                width: 204px;
                height: 50px;
                font-weight: 700;
                border-radius: 5px;
                font-size: 16px;
              "
              class="action"
              @click="$router.push('/')"
              >{{ $t("addproperty.cancel") }}
            </v-btn>
            <v-btn
              style="
                color: white;
                width: 204px;
                letter-spacing: 0;
                font-weight: 700;
                border-radius: 5px;
                font-size: 16px;
              "
              color="#04a777"
              class="save_button"
              :loading="loadingPictureButton"
              @click="onSaveLocalPicture"
              >{{ $t("save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="480"
      v-model="isOpenDeleteDialog"
    >
      <template>
        <v-card>
          <v-toolbar color="#fff" dark>
            <span class="delete_page">
              {{ $t("remove_account") }}
            </span>
          </v-toolbar>
          <v-card-text style="padding-top: 40px">
            <div>
              <v-text-field
                :label="$t('password_text')"
                :append-icon="
                  showPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                "
                :type="showPass ? 'text' : 'password'"
                @click:append="showPass = !showPass"
                v-model="deletePassword"
                color="#04a777"
                outlined
                dense
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions class="justify-center align-center">
            <v-btn
              style="width: 177px; height: 42px; color: #fff"
              class="cancel_btn"
              color="#fff"
              @click="isOpenDeleteDialog = false"
              ><span style="color: #010302">
                {{ $t("addproperty.cancel") }}</span
              ></v-btn
            >
            <v-btn
              class="delete_btn"
              :loading="deleteAccountLoading"
              id="custom-disabled"
              style="color: white; width: 177px; height: 42px"
              color="#04a777"
              @click="handleDeleteAccount"
              >{{ $t("mainFilters.delete") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- AddLogo Dialog -->

    <v-dialog
      transition="dialog-bottom-transition"
      :max-width="754"
      v-model="isOpenAddLogoDialog"
    >
      <template>
        <v-card>
          <v-toolbar class="upload-logo-header" color="#fff" dark>
            <span class="upload-logo-title">
              {{ $t("edit") }}
            </span>
          </v-toolbar>
          <v-card-text style="padding-top: 23px" class="upload-logo">
            <div class="upload-logo-box">
              <label style="cursor: pointer; width: fit-content" class="upload-file">
                <div class="upload-logo-btn">
                  <img
                  class=""
                  src="@/assets/images/icons/upload.svg"
                  alt="upload"
                  />
                  <span>{{ $t("photoUpload.uploadLogo") }}</span>
                </div>
                <input
                  type="file"
                  class="file"
                  @change="uploadLogo($event)"
                  style="display: none"
                  id="file"
                  ref="files"
                  name="file[]"
                  multiple
                  accept="image/*"
                  />
              </label>
              <div class="logo-img-box">
                <vue-draggable-resizable
                  :left="10"
                  :active="true" 
                  ref="logo-resize-box" 
                  v-if="logoUrl.src"
                  :w="logoImgSizes.width" 
                  :h="logoImgSizes.height" 
                  :min-height="35" 
                  :min-width="35"
                  :x="118"
                  :y="62" 
                  :parent="true"
                  :handles="['tl', 'tr', 'br', 'bl']" 
                  @resizing="onResize"
                >
                  <img :width="`${logoImgSizes.width}px`" :height="`${logoImgSizes.height}px`" :src="logoUrl.src" alt="logo">
                </vue-draggable-resizable>
                <img width="100%" height="100%" src="../../assets/images/home-default-1.jpg" alt="home-default">
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-center align-center">
            <v-btn
              style="width: 177px; height: 42px; color: #fff"
              class="cancel_btn"
              color="#fff"
              @click="closeLogoDialog"
              ><span style="color: #010302">
                {{ $t("addproperty.cancel") }}</span
              ></v-btn
            >
            <v-btn
              class="delete_btn"
              id="custom-disabled"
              style="color: white; width: 177px; height: 42px"
              color="#04a777"
              @click="isOpenAddLogoDialog = false"
              >{{ $t("save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-snackbar
      color="red"
      height="40"
      v-model="isShownErrorSnackbar"
      v-for="(item, key, index) in graphQLErrors"
      :key="`errorSnackbar_${index}`"
    >
      <div class="mt-4">
        <div v-if="!isString(item)">
          <p v-for="(error, i) in item" :key="`error_${i}`">
            {{ error }}
          </p>
        </div>
        <div v-else>
          {{ item }}
        </div>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="isShownErrorSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="red" height="40" v-model="isShowDeleteAccountSnackbar">
      <div class="mt-4">
        <div>
          <p>
            {{ deleteAccountErrors }}
          </p>
        </div>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="isShowDeleteAccountSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
  <div v-else class="main-loader">
    <v-progress-circular
      indeterminate
      color="#04a777"
      size="70"
    ></v-progress-circular>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import countryCodes from "../../data/countryCodes.json";
//components
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import VuePhoneNumberInput from "vue-phone-number-input";
//styles
import "vue-advanced-cropper/dist/style.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  name: "Settings.vue",
  components: {
    Cropper,
    VuePhoneNumberInput,
  },
  data() {
    return {
      logoImgSizes: {
        width: 70,
        height: 70,
      },
      logoUrl: {},
      zoom: {
        input: 0,
        value: 0,
      },
      isUploadedImg: false,
      countryCodes,
      userEditImageSrc: null,
      profile: {
        full_name: null,
        phones: [],
        email: null,
        old_password: null,
        password: null,
        password_confirmation: null,
        user_type: null,
       

      },
      showPass: false,
      showPass2: false,
      showPass3: false,
      deletePassword: null,
      stencil: CircleStencil,
      newNumber: {
        number: null,
        options: {},
        whatsapp: false,
        viber: false,
        telegram: false,
      },
      loading: false,
      phoneLoaders: [],
      buttonLoading: false,
      loadingPictureButton: false,
      isBlured: true,
      isOpenEditPictureDialog: false,
      isOpenDeleteDialog: false,
      isOpenAddLogoDialog: false,
      isOpenAddDialog: false,
      isOpenEditDialog: false,
      isOpenPhoneWarning: false,
      isOpenEditWarning: false,
      editMode: {
        email: false,
        password: false,
        user_type: false,
        full_name: false,
      },
      profilePictureSrc: {},
      formData: new FormData(),
      apolloToken: localStorage.getItem("apollo-token"),
      graphQLErrors: {},
      isShownErrorSnackbar: false,
      isShowDeleteAccountSnackbar: false,
      deleteAccountErrors: null,
      deleteAccountLoading: false,
      isProfilePictureError: false,
      editingPhoneNumber: "",
      editingNumber: {
        number: null,
        options: {},
        whatsapp: false,
        viber: false,
        telegram: false,
        defCode: null,
        phones: [],
      },
      editingPhoneId: null,
    };
  },
  validations: {
    profile: {
      full_name: { required },
    },
  },
  watch: {
    userProfile() {
      this.profile.full_name = this.userProfile.full_name;
      this.profile.email = this.userProfile.email;
      this.profile.user_type = this.userProfile.user_type.name;
      this.profilePictureSrc = {
        src: this.userProfile.picture.original,
        type: "image/jpeg",
      };
      this.profile.phones = [];
      this.phoneLoaders = Array(this.userProfile.phones.length).fill(false);
      for (let i in this.userProfile.phones) {
        this.profile.phones.push({
          phone_id: this.userProfile.phones[i].id,
          number: this.userProfile.phones[i].number,
          viber: this.userProfile.phones[i].viber,
          whatsapp: this.userProfile.phones[i].whatsapp,
          telegram: this.userProfile.phones[i].telegram,
          defCode: this.userProfile.phones[i].code,
          options: {},
        });
      }
    },
  },
  computed: {
    userTypes() {
      return [
        {
          name: this.$t("mainFilters.individual"),
          type: "individual",
          selected: true,
        },
        { name: this.$t("mainFilters.agency"), type: "agency", selected: true },
      ];
    },
    phoneNumber() {
      let phoneNumberForamt = "123456".match(/.{1,2}/g).join("-");
      return phoneNumberForamt;
    },
  },
  methods: {
    closeLogoDialog() {
      this.isOpenAddLogoDialog = false;
      this.logoUrl = {};
    },
    onResize(x, y, width, height) {
      this.logoImgSizes.width = width;
      this.logoImgSizes.height = height;
    },
    uploadLogo(event) {
      const { files } = event.target;
      if (files && files[0]) {
        const blob = URL.createObjectURL(files[0]);
        this.logoUrl = {
          src: blob,
          type: files[0].type,
        };  
      }
    },
    onChange() {
      const cropper = this.$refs.cropper;
      if (cropper) {
        const { coordinates, imageSize } = cropper;
        if (
          imageSize.width / imageSize.height >
          coordinates.width / coordinates.height
        ) {
          // Determine the position of slider bullet
          // It's 0 if the stencil has the maximum size and it's 1 if the has the minimum size
          this.zoom.value =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom.value =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
        this.zoom.input = this.zoom.value;
      }
    },
    onZoom(value) {
      const cropper = this.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          const imageHeight = cropper.imageSize.height;
          // Determine the current absolute zoom and the new absolute zoom
          // to calculate the sought relative zoom value
          cropper.zoom(
            (imageHeight - this.zoom.value * (imageHeight - minHeight)) /
              (imageHeight - value * (imageHeight - minHeight))
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          const imageWidth = cropper.imageSize.width;
          cropper.zoom(
            (imageWidth - this.zoom.value * (imageWidth - minWidth)) /
              (imageWidth - value * (imageWidth - minWidth))
          );
        }
        this.zoom.value = value;
      }
    },
    sliderAppend() {
      if (this.zoom.input < 1) {
        this.zoom.input += 0.1;
        if (this.zoom.input > 1) {
          this.zoom.input = 1;
        }
        this.onZoom(this.zoom.input);
      }
    },
    sliderPrepend() {
      if (this.zoom.input > 0) {
        this.zoom.input -= 0.1;
        if (this.zoom.input < 0) {
          this.zoom.input = 0;
        }
        this.onZoom(this.zoom.input);
      }
    },
    onNewNumberUpdate(obj) {
      this.newNumber.options = obj;
    },
    onProfilePictureError(e) {
      if (this.userEditImageSrc) {
        this.isProfilePictureError = true;
      }
      e.target.src = require("@/assets/images/User image.png");
    },
    closeEditPicture() {
      this.profilePictureSrc = {
        src: this.userProfile.picture.original,
        type: "image/jpeg",
      };
      this.isOpenEditPictureDialog = false;
      this.isUploadedImg = false;
    },
    onClickDeleteProfile() {
      this.isOpenDeleteDialog = true;
    },
    onClickAddLogo() {
      this.isOpenAddLogoDialog = true;
    },
    CloseSaving() {
      this.$router.push("/");
    },
    onPhoneUpdate(index, obj) {
      this.profile.phones[index].options = obj;
    },
    onAddPhone() {
      this.isOpenAddDialog = true;
    },
    onEditPhone(index, id) {
      this.isOpenEditDialog = true;
      this.editingPhoneId = +id;
      this.editingPhoneNumber = this.profile.phones[index].number;
      this.editingNumber.viber = this.userProfile.phones[index].viber;
      this.editingNumber.whatsapp = this.userProfile.phones[index].whatsapp;
      this.editingNumber.telegram = this.userProfile.phones[index].telegram;
      this.editingNumber.defCode = this.profile.phones[index].defCode;
    },
    warningPhoneShow(e) {
      if (e === "info") {
        this.isOpenPhoneWarning = true;
      } else if (e === "edit") {
        this.isOpenEditWarning = true;
      }
    },
    warningPhoneHide(e) {
      if (e === "info") {
        this.isOpenPhoneWarning = false;
      } else if (e === "edit") {
        this.isOpenEditWarning = false;
      }
    },
    isString(item) {
      return typeof item === "string";
    },
    uploadImage(event) {
      this.isProfilePictureError = false;
      const { files } = event.target;
      if (files && files[0]) {
        if (this.profilePictureSrc.src) {
          URL.revokeObjectURL(this.profilePictureSrc.src);
        }
        const blob = URL.createObjectURL(files[0]);
        this.profilePictureSrc = {
          src: blob,
          type: files[0].type,
        };
        this.isUploadedImg = true;
      }
    },
    getProviderIcon(provider) {
      if (provider === "google") {
        return require("@/assets/images/icons/google-icon.svg");
      } else {
        return require("@/assets/images/icons/facebookIcon.svg");
      }
    },
    handleAddPhone() {
      this.buttonLoading = true;
      const phone = {
        code: this.newNumber.options.countryCallingCode,
        viber: this.newNumber.viber,
        whatsapp: this.newNumber.whatsapp,
        telegram: this.newNumber.telegram,
        number: this.newNumber.number,
      };
      this.$apollo
        .mutate({
          mutation: gql`
            mutation updateUserProfile($phone: [NewPhone!]) {
              updateUserProfile(input: { phone: $phone }) {
                id
              }
            }
          `,
          variables: {
            phone: [phone],
          },
        })
        .then(() => {
          this.$apollo.queries.userProfile.refetch().then((data) => {
            this.userProfile = data.data.userProfile;
            this.buttonLoading = false;
            this.onCloseAddNumber();
          });
        });
    },
    handleEditPhone() {
      this.buttonLoading = true;

      const phone = {
        phone_id: this.editingPhoneId,
        code: this.editingNumber.defCode,
        viber: this.editingNumber.viber,
        whatsapp: this.editingNumber.whatsapp,
        telegram: this.editingNumber.telegram,
        number: this.editingPhoneNumber,
      };
      this.$apollo
        .mutate({
          mutation: gql`
            mutation updateUserProfile($update_phone: [UpdatePhone!]) {
              updateUserProfile(input: { update_phone: $update_phone }) {
                id
              }
            }
          `,
          variables: {
            update_phone: [phone],
          },
        })
        .then(() => {
          this.loading = false;
          this.editingPhoneId = null;
          this.$apollo.queries.userProfile.refetch().then((data) => {
            this.userProfile = data.data.userProfile;
            this.buttonLoading = false;
            this.isOpenEditDialog = false;
          });
        });
    },
    onCloseAddNumber() {
      this.isOpenAddDialog = false;
      this.newNumber = {
        number: null,
        whatsapp: false,
        viber: false,
        telegram: false,
        options: {},
      };
    },
    onCloseEditNumber() {
      (this.isOpenEditDialog = false),
        (this.newNumber = {
          number: null,
          whatsapp: false,
          viber: false,
          telegram: false,
          options: {},
        });
    },
    onDeletePhone(id, index) {
      this.phoneLoaders.splice(index, 1, true);
      this.$apollo
        .mutate({
          mutation: gql`
            mutation updateUserProfile($delete_phone: [Int!]) {
              updateUserProfile(input: { delete_phone: $delete_phone }) {
                id
              }
            }
          `,
          variables: {
            delete_phone: id,
          },
        })
        .then(() => {
          this.$apollo.queries.userProfile.refetch().then((data) => {
            this.phoneLoaders.splice(index, 1, false);
            this.userProfile = data.data.userProfile;
          });
        });
    },
    handleSaveSettings() {
      console.log(this.userProfile.user_type.name, this.profile.user_type);
      this.onSaveImage();
      const obj = { ...this.profile };
      if (obj.email === this.userProfile.email) {
        delete obj.email;
      }
      -delete obj.phones;
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation updateUserProfile($input: updateUserProfileInput) {
              updateUserProfile(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: obj,
          },
        })
        .then(() => {
          this.loading = false;
          this.$apollo.queries.userProfile.refetch().then((data) => {
            this.userProfile = data.data.userProfile;
            localStorage.setItem("user-type", this.userProfile.user_type.name);
          });
          this.$swal.fire({
            position: "center",
            icon: "success",
            title: "",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((e) => {
          this.graphQLErrors = e.graphQLErrors[0].extensions.validation
            ? e.graphQLErrors[0].extensions.validation
            : e.graphQLErrors[0].extensions.errors;
          this.isShownErrorSnackbar = true;
          this.loading = false;
        });
      this.editMode.full_name = false;
      this.editMode.email = false;
      this.editMode.password = false;
      this.editMode.user_type = false;
    },
    onCancelEditPassword() {
      this.profile.old_password = null;
      this.profile.password = null;
      this.profile.password_confirmation = null;
      this.editMode.password = false;
    },
    onEditPicture() {
      this.isOpenEditPictureDialog = true;
    },
    DataURIToBlob(dataURI) {
      const splitDataURI = dataURI.split(",");
      const byteString =
        splitDataURI[0].indexOf("base64") >= 0
          ? atob(splitDataURI[1])
          : decodeURI(splitDataURI[1]);
      const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i);
      return new Blob([ia], { type: mimeString });
    },
    findCode(index) {
      if (
        this.profile.phones &&
        this.profile.phones[index].defCode &&
        this.profile.phones[index].defCode[0] !== "+"
      ) {
        this.profile.phones[
          index
        ].defCode = `+${this.profile.phones[index].defCode}`;
        return this.countryCodes.find(
          (el) => el.dial_code === this.profile.phones[index].defCode
        ).code;
      } else return "";
    },
    onSaveLocalPicture() {
      if (!this.$refs.cropper) {
        return;
      }
      const { canvas } = this.$refs.cropper.getResult();
      var dataURL = canvas.toDataURL("image/jpeg");
      this.userEditImageSrc = dataURL;
      this.handleSaveSettings();
      this.isUploadedImg = false;
      this.isOpenEditPictureDialog = false;
    },
    onSaveImage() {
      if (this.$refs.cropper) {
        this.loadingPictureButton = true;

        const { canvas } = this.$refs.cropper.getResult();
        var dataURL = canvas.toDataURL("image/jpeg");
        const query = `
          mutation updateUserProfile($image: Upload!) {
            updateUserProfile(input: { image: $image }) {
              id
            }
          }
          `;
        const variables = {
          image: null,
        };
        const operations = JSON.stringify({ query, variables: variables });
        this.formData.append("operations", operations);
        const map = {
          image: ["variables.image"],
        };
        this.formData.append("map", JSON.stringify(map));
        const imgBase64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
        const file = this.DataURIToBlob(imgBase64);
        this.formData.append("image", file);
        axios
          .post(process.env.VUE_APP_API_URL, this.formData, {
            headers: { Authorization: `Bearer ${this.apolloToken}` },
          })
          .then(() => {
            this.$apollo.queries.userProfile.refetch().then((data) => {
              this.userProfile = data.data.userProfile;
              console.log(this.$refs.cropper);
              this.loadingPictureButton = false;
              // this.$refs.cropper.refresh();
              this.isOpenEditPictureDialog = false;
              this.profilePictureSrc = {
                src: data.data.userProfile.picture.original,
                type: "image/jpeg",
              };
              this.$root.$emit("onChangePicture", this.profilePictureSrc.src);
            });
          });
      }
    },
    onAddLogo() {
      this.$router.push("/user/logo");
    },
    handleDeleteAccount() {
      this.deleteAccountLoading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation deleteUserProfile($password: String!) {
              deleteUserProfile(password: $password)
            }
          `,
          variables: {
            password: this.deletePassword,
          },
        })
        .then(() => {
          window.location.href = "/login";
        })
        .catch((error) => {
          this.deleteAccountLoading = false;
          this.isShowDeleteAccountSnackbar = true;
          this.deleteAccountErrors = error.graphQLErrors[0].message;
        });
    },
  },
  apollo: {
    userProfile: {
      query: gql`
        query {
          userProfile {
            id
            is_admin
            full_name
            picture {
              min
              original
            }
            email
            phones {
              id
              code
              number
              viber
              whatsapp
              telegram
            }
            provider
            user_type {
              name
            }
          }
        }
      `,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
.upload-logo-header {
  height: 77px !important;
}
.upload-logo-header >>> .v-toolbar__content {
  height: 77px !important;
  border: none;
  box-shadow: 0px 4px 10px rgba(16, 15, 15, 0.16) !important; 
}
.upload-logo-title {
  font-weight: 700;
  font-size: 30px;
  line-height: 41px;
  color: #010101;
}
.upload-logo-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vdr {
  border: 2px dashed transparent;
  cursor: all-scroll;
}
.vdr.active {
  border: 2px dashed #656565;
}
.logo-img-box {
  width: 306px;
  height: 193px;
  position: relative;
  margin-top: 19px;
  margin-bottom: 26px;
}
.logo-img-box img:first-child {
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
} 
.logo-img-box img:last-child {
  user-select: none;
  pointer-events: none;
}
::v-deep .handle {
  border: none;
  background: #4C4A4B;
  width: 7px;
  height: 7px;
}
::v-deep .handle-tl {
  top: -7px;
  left: -7px;
}
::v-deep .handle-tr {
  top: -7px;
  right: -7px;
}
::v-deep .handle-br {
  bottom: -7px;
  right: -7px;
}
::v-deep .handle-bl {
  bottom: -7px;
  left: -7px;
}      
.upload-logo-btn {
  padding: 10px 15px;
  border: solid 1px #656565;
  border-radius: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-transform: capitalize;
}
.upload-logo-btn span {
  padding-left: 15px;
}
.custom-placeholer-color >>> input::placeholder,
.custom-input >>> input::placeholder {
  color: #a3a4a3 !important;
  opacity: 1;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  font-style: normal !important;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
  border: 1px solid #c4c4c4;
  height: 40px;
}
::v-deep .v-toolbar__content{
  border-bottom: 1px solid #a3a4a3;
}
::v-deep
  .save-btn-new.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default:hover {
  background-color: #04a777 !important ;
}
::v-deep
  .save-btn-new.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default:hover
  span
  img {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(342deg)
    brightness(200%) contrast(200%);
}
::v-deep
  .cancel-btn-new.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default:hover {
  background-color: #656565 !important ;
}
::v-deep
  .cancel-btn-new.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default:hover
  span
  img {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(342deg)
    brightness(200%) contrast(200%);
}
::v-deep .theme--light.v-btn.v-btn--has-bg {
  background: #fff;
}
.user-type-select {
  margin-right: 32px;
}
.user-type-div {
  max-width: 506px;
  margin-top: 15px;
}
.btns-position {
  margin-top: 15px;
}
.save-btn-new {
  min-width: 32px !important;
  height: 32px !important;
  border: 1px solid #04a777 !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.cancel-btn-new {
  min-width: 32px !important;
  height: 32px !important;
  border: 1px solid #656565 !important;
  margin-left: 10px;
  box-shadow: none !important;
  padding: 0 !important;
}

.btns-position {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.slider-icons {
  cursor: pointer;
  font-weight: bold;
}
.cropper-file-uploade {
  border-radius: 50%;
  position: absolute;
  right: -30px;
  bottom: -30px;
  cursor: pointer;
  width: 61px;
  height: 61px;
  display: flex;
  background: #d9d9d9;
  justify-content: center;
  align-items: center;
  border: 3px solid #fff;
}
.file-input-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 36px;
  margin-bottom: 40px;
}
.v-dialog > .v-card > .v-card__actions {
  padding-bottom: 50px;
}
.v-dialog > .v-card > .v-card__subtitle,
.v-dialog > .v-card > .v-card__text.dialog-body {
  padding-top: 31px;
}
.cropper-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cropper-wrapper {
  position: relative;
  width: 367px;
  height: 367px;
}
.cropper,
cropper * {
  width: 100%;
  height: 100%;
}
.v-tooltip__content {
  color: black;
  background: #ffffff;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.23);
  border-radius: 2px solid black;
}
.no-image-text-box {
  height: 300px;
  align-items: center;
  place-content: center;
  align-content: center;
  place-items: center;
  display: grid;
  font-size: 36px;
  color: black;
}
.main-loader {
  width: 100%;
  height: 100vh;
  display: grid;
  align-content: center;
  align-items: center;
  place-content: center;
  align-content: center;
}
.main-wrapper {
  width: 75%;
  margin: 130px auto;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding-left: 0px !important;
}
.main-title {
  font-size: 24px;
  font-weight: 600;
  padding: 45px 0px 35px 55px !important;
}
.main-picture {
  display: flex;
  gap: 28px;
  align-items: center;
}
.picture-part {
  display: flex;
  align-items: center;
}
#custom-disabled.v-btn--disabled {
  background-color: #04a777 !important;
  color: white !important;
}
.main-picture,
.main-title,
.main-name {
  padding: 19px 28px 0 20px;
}
.main-user_type,
.main-user_email,
.main-user_password,
.main-user_phone,
.main-delete-user {
  padding: 0 28px 0 20px;
}
.main-user_type span,
.main-user_password span,
.main-user_email span,
.main-user_phone span {
  font-weight: 600;
}
a {
  color: #004af1;
  font-weight: 700;
}
.new-number-part {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
}
.phone-numbers {
  display: flex;
  align-items: flex-start;
}
.phone-number_input {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.divider {
  border-width: 1px;
  border-color: black;
}
.span-add-logo {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 22px !important;
}
[class^="main-"] {
  padding-left: 55px;
}
.profile-picture {
  border-radius: 50%;
}
.main-name label {
  display: block;
  font-weight: 600;
  margin-bottom: 15px;
}
.user-input {
  width: 400px;
  min-height: 40px;
  border-radius: 5px;
  border: 1px solid #c4c4c4 !important;
  margin-right: 32px;
  box-shadow: none;
  text-indent: 10px;
}
.user-text-field {
  width: 400px;
  min-height: 40px;
  border-radius: 5px;
  margin-right: 32px;
  box-shadow: none;
  text-indent: 10px;
}
.user-input .v-input__slot {
  margin-bottom: 2px;
}
.checkmark >>> label {
  left: 5px !important;
  color: #555555;
  top: 5px;
}
.add-new-phone-button {
  width: 190px;
  box-shadow: 0 0 6px 0 rgba(1, 3, 2, 0.15);
  border: none !important;
  text-transform: capitalize !important;
  margin-left: 7px;
  margin-right: 10px;
}
.add-new-phone-button >>> .v-btn__content {
  gap: 0 34px;
}
.warning-box_phone {
  top: 35px;
  left: 85px;
  width: 235px;
}
.warning-box_edit {
  top: 27px;
  left: -23px;
}
.warning-box {
  position: absolute;
  transform: translate(-50% -50%);
  padding: 10px 12px;
  border-radius: 5px;
  background: #fff;
  z-index: 1;
  box-shadow: -1px -1px 24px 1px rgba(34, 60, 80, 0.2);
  font-size: 12px;
  color: black;
}
.attached-phone div {
  display: flex;
  flex-wrap: nowrap;
}
.attached-phone {
  align-items: flex-start !important ;
}
.user-select {
  height: 48px;
  width: 88px;
  border: 1px solid black;
  border-radius: 5px;
  margin-right: 20px;
  color: black;
  padding-left: 8px;
}
.error-input {
  border-color: #e91d46;
}
.error-message {
  display: block;
}
.red {
  color: #e91d46;
  background: transparent !important;
}
.d-flex {
  display: flex;
  align-items: center;
}
.label {
  font-weight: 400 !important;
}
.add-number,
.main-add-logo {
  padding-left: 55px !important;
  color: #04a777;
  gap: 25px;
  cursor: pointer;
}
.main-user_phone-wrapper {
  display: flex;
  padding: 0px 0px 0px 8px;
}
.main-delete-user {
  gap: 28px;
  padding-bottom: 20px;
}
.delete_page {
  color: #010302;
  font-weight: 700;
  font-size: 17px;
  line-height: 23px;
}
.upload-logo{
  display: flex;
  justify-content: center;
}
::v-deep .v-toolbar__content {
  display: flex !important;
  justify-content: space-evenly !important;
}
::v-deep.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
::v-deep .v-card__text {
  padding-bottom: 0 !important;
}
::v-deep .v-card__actions {
  padding-bottom: 45px !important;
}
.cancel_btn {
  box-shadow: none !important;
  border: 1px solid #656565 !important;
}
.cancel_btn:hover {
  box-shadow: 2px 2px 11px rgba(0, 0, 0, 0.3) !important;
}
.delete_btn:hover {
  box-shadow: 2px 2px 11px rgba(0, 0, 0, 0.4) !important;
}
.main-actions {
  display: flex;
  justify-content: center;
  margin-bottom: 19px;
  gap: 0 15px;
}
.main-actions button {
  width: 196px;
  height: 48px;
  background: #04a777;
  color: white;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 600;
}
.mb-2 {
  margin-bottom: 8px;
}
.edit-picture-header {
  display: flex;
  align-items: center;
  width: 1030px;
  height: 127px !important;
  color: black;
  display: flex;
  justify-content: center;
  font-weight: 600;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 41px;
  box-shadow: 0px 4px 10px rgba(16, 15, 15, 0.16) !important;
}
.custom-file-upload {
  width: 140px;
  height: 40px;
  display: flex;
  align-items: center;
  place-content: center;
  place-items: center;
  cursor: pointer;
  background: #e4e6eb;
  padding: 25px 15px 25px 15px;
}
.save_button {
  padding: 25px 15px 25px 15px !important;
}
input:disabled {
  color: rgba(0, 0, 0, 0.87);
}
.new-number-part div:last-child {
  border: none;
}
@media only screen and (max-width: 1368px) {
  .new-number-part {
    display: block !important;
  }
  .phone-numbers {
    display: block;
    margin-bottom: 20px;
  }
  .phone-number_input {
    margin-left: 0;
  }
  .warning-box {
    top: 0;
  }
  .main-user_phone-wrapper {
    border: none;
    margin-top: 16px;
  }
}
@media only screen and (max-width: 990px) {
  .main-wrapper {
    margin: 100px auto 50px;
  }
}
@media only screen and (max-width: 800px) {
  .btns-position {
    flex-direction: column;
    align-items: flex-start;
  }
  .user-type-div {
    display: flex !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    flex-direction: column !important;
  }
  .btns {
    margin-top: 16px;
  }
}
@media only screen and (max-width: 666px) {
  .main {
    padding-top: 0;
  }
  .user-input,
  .user-select {
    font-size: 14px;
  }
  .main-wrapper {
    width: 100%;
    margin: 50px auto 0;
  }
  .picture-part {
    width: 100%;
    justify-content: space-between;
  }
  /* .change-email {
    margin-left: 0 !important;
  } */
  .warning-box {
    top: 30px;
    left: 48px;
  }
  /* .edit-mobile {
    display: flex;
    justify-content: space-between;
  }
  .main-user_phone-wrapper {
    display: flex;
    justify-content: space-between;
  } */
  .main-title {
    padding: 25px 0px 5px 55px !important;
  }
}

@media only screen and (max-width: 525px) {
  .main-title,
  .main-name,
  .main-user_type,
  .main-user_email,
  .main-user_password,
  .main-user_phone {
    padding-left: 16px !important;
  }
  .main-title,
  .main-name,
  .main-user_type,
  .main-user_email,
  .main-user_password,
  .main-user_phone {
    padding-right: 16px !important;
  }
  .user-input {
    max-width: 100%;
  }
  .user-type-select {
    margin-right: 0 !important;
  }
}
@media only screen and (max-width: 425px) {
  .account_number {
    gap: 25px !important;
  }
  .main-actions button {
    width: 148px;
  }
}
@media only screen and (max-width: 375px) {
  .account_number {
    gap: 5px !important;
  }
  .pencil-icon {
    margin-left: 5px !important;
  }
}
@media only screen and (max-width: 320px) {
  .account_number {
    gap: 0px 30px !important;
    flex-wrap: wrap;
  }
}
</style>
